import { defineStore } from 'pinia';
import { AxiosError } from 'axios';
import { ref } from 'vue';
import { handleApiCall } from '@/utils/storeHelpers';
import { GradesOptions, PersonGrades, PersonGradesRequest } from '@/types/GradeInterface';
import GradeService from '@/services/GradeService';

export const useGradeStore = defineStore('GradeStore', () => {
  const loading = ref(false);
  const error = ref<AxiosError | unknown | null>(null);
  const gradesOptions = ref<GradesOptions[]>([]);
  const personGrades = ref<PersonGrades[]>([]);

  async function fetchGradesOptions() {
    return handleApiCall(
      () => GradeService.getGradesOptions(),
      loading,
      error,
      (res) => {
        gradesOptions.value = res;
      },
    );
  }

  async function fetchPersonGrades(person_id: number) {
    return handleApiCall(
      () => GradeService.getPersonGrades(person_id),
      loading,
      error,
      (res) => {
        personGrades.value = res;
      },
    );
  }

  async function attachPersonGrades(data: PersonGradesRequest, person_id: number, organization_id: number) {
    return handleApiCall(() => GradeService.attachPersonGrades(data, person_id, organization_id), loading, error);
  }

  async function detachPersonGrades(data: PersonGradesRequest, person_id: number, organization_id: number) {
    return handleApiCall(() => GradeService.detachPersonGrades(data, person_id, organization_id), loading, error);
  }

  return {
    loading,
    error,
    gradesOptions,
    personGrades,
    fetchGradesOptions,
    fetchPersonGrades,
    attachPersonGrades,
    detachPersonGrades,
  };
});

export default useGradeStore;
